import { SoundCategory } from '../../services/SoundLibrary/soundCategory';
import Button from 'react-bootstrap/Button';
import React, { useState } from 'react';
import { variantMap } from './SoundCategoryListItem';
import SoundManager from '../../services/SoundManager';

export interface PlaySoundCategoryButtonProps {
  category: SoundCategory;
}

export default function PlaySoundCategoryButton({ category }: PlaySoundCategoryButtonProps) {
  const [playing, setPlaying] = useState(false);
  const variant = playing ? 'danger' : `outline-${variantMap[category.supported] || 'success'}`;
  const [alternateClickFn, setAlternateClickFn] = useState<() => void>();

  const onClick = () => {
    const randomSound = category.randomSound();
    if (!randomSound) return;

    const data = {
      trackedStarts: 0,
    };

    SoundManager.playFromUrlNew({
      url: randomSound.soundLocation,
      onStart(stop: () => void) {
        data.trackedStarts++;
        setAlternateClickFn(() => () => {
          stop();
          setAlternateClickFn(undefined);
        });
        setPlaying(true);
      },
      onEnd() {
        data.trackedStarts--;
        setAlternateClickFn(undefined);
        setPlaying(data.trackedStarts > 0);
      },
      stateChanged: setPlaying,
    });
  };

  return <Button type="button" variant={variant} onClick={() => (alternateClickFn || onClick)()} size="lg">
    <i className={`bi-${playing ? 'stop' : 'play'}`}/>
  </Button>;
}
